var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136 176.142 959.87.012-.248 960.131 959.87 1920 1136 1743.87 352.136 960.131 1136 176.142Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 176.142 1743.87.012 783.752 960.131 1743.87 1920 1920 1743.87l-783.86-783.739L1920 176.142Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFirst);
export default __webpack_public_path__ + "static/media/searchFirst.40d5e0299f76e777f456082bd8559570.svg";
export { ForwardRef as ReactComponent };